/** Failed operations must not poison subsequent account or connection work. */
export function connectOperationQueue() {
  let pending: Promise<unknown> = Promise.resolve();
  return <A>(operation: () => Promise<A>) => {
    const result = pending.then(operation, operation);
    pending = result.catch(() => undefined);
    return result;
  };
}
